export default __webpack_public_path__ + "static/859-9dd3bb9380218d38b20101d074116e65.gif";